import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { navigationItems } from '../../data/mock';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (href) => location.pathname === href;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center group flex-shrink-0" aria-label="Zur Startseite">
            <img 
              src="/unternehmenbewerten-logo.webp" 
              alt="unternehmenbewerten.ch Logo" 
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-1" role="navigation" aria-label="Hauptnavigation">
            {navigationItems.slice(0, 7).map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap ${
                  isActive(item.href)
                    ? 'text-white bg-[#FF0000]'
                    : 'text-[#1a1c1b] hover:text-[#FF0000] hover:bg-[#FFE5E5]'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Phone + CTA Button */}
          <div className="hidden lg:flex items-center gap-4">
            <a 
              href="tel:+41582205550" 
              className="flex items-center gap-2 text-sm text-[#5a5d5b] hover:text-[#FF0000] transition-colors whitespace-nowrap"
              aria-label="Anrufen"
              onClick={() => {
                if (typeof window !== 'undefined' && window.gtag) {
                  window.gtag('event', 'contact_phone_click', {
                    event_category: 'contact',
                    method: 'phone'
                  });
                }
              }}
            >
              <Phone size={16} className="flex-shrink-0" />
              <span className="font-medium">+41 58 220 55 50</span>
            </a>
            <Link
              to="/bewertung"
              className="btn-primary text-sm px-6 whitespace-nowrap"
            >
              Unternehmenswert berechnen
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 rounded-lg text-[#1a1c1b] hover:text-[#FF0000] hover:bg-[#FFE5E5] transition-colors"
            aria-label={isMenuOpen ? "Menü schliessen" : "Menü öffnen"}
            aria-expanded={isMenuOpen}
          >
            {isMenuOpen ? <X size={24} aria-hidden="true" /> : <Menu size={24} aria-hidden="true" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <nav className="px-4 py-6 space-y-2">
            {navigationItems.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                onClick={() => setIsMenuOpen(false)}
                className={`block px-4 py-3 rounded-lg text-base font-medium transition-colors ${
                  isActive(item.href)
                    ? 'text-white bg-[#FF0000]'
                    : 'text-[#1a1c1b] hover:text-[#FF0000] hover:bg-[#FFE5E5]'
                }`}
              >
                {item.label}
              </Link>
            ))}
            {/* Phone number in mobile menu */}
            <a 
              href="tel:+41582205550" 
              className="flex items-center gap-3 px-4 py-3 rounded-lg text-base font-medium text-[#5a5d5b] hover:text-[#FF0000] hover:bg-[#FFE5E5] transition-colors"
              onClick={() => {
                if (typeof window !== 'undefined' && window.gtag) {
                  window.gtag('event', 'contact_phone_click', {
                    event_category: 'contact',
                    method: 'phone'
                  });
                }
              }}
            >
              <Phone size={20} />
              +41 58 220 55 50
            </a>
            <div className="pt-4">
              <Link
                to="/bewertung"
                onClick={() => setIsMenuOpen(false)}
                className="btn-primary w-full text-center"
              >
                Jetzt Firmenbewertung starten
              </Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
